import Button from "components/form-elements/buttons/Button";
import ReactSelect from "components/form-elements/select/ReactSelect";
import { useRequest } from "hooks/useRequest";
import { useEffect, useState } from "react"
//import { toast } from "react-toastify";
import { stages } from "utils/Constants";
import LoaderTwo from "pages/LoaderTwo";
import useTranslate from "hooks/useTranslate";
import {useDispatch} from "react-redux";
import {updateUserChoises} from "redux/features/general/generalSlice";
import {dataLayerPush} from "utils/Datalayer";

const ChoiceBranch = ({forHome, setRegisterState}) => {
    const [request,loading] = useRequest();
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const {t} = useTranslate()
    const dispatch = useDispatch()
    //const [streets, setStreets] = useState([]);
    //const [buildings, setBuildings] = useState([]);
  
    const [addressInfo, setAddressInfo] = useState({
        province: "",
        provinceId: null,
        district: "",
        districtId: null,
        neighbourhood: "",
        neighbourhoodId: null,
      })

    
      useEffect(() => {
        request('/Location/Provinces', {
          method: 'GET',
        }).then((res) => {
          if (res) {
            //setAddressInfo({...addressInfo, })
            setProvinces(res?.data?.result?.map(province => ({ value: province.name, label: province.name, id: province.provinceId })))
            if (addressInfo?.provinceId) {
              request(`/Location/Districts/${addressInfo?.provinceId}`, {
                method: "GET"
              })
                .then((res) => {
                  setDistricts(res?.data?.result?.map(district => ({ value: district.name, label: district.name, id: district.districtId })))
                })
            }
    
          }
        })
      }, [addressInfo?.provinceId, addressInfo?.districtId, addressInfo?.neighbourhoodId])
    


      const handleChange = (e, name, id) => {
        if (name && id) {
          if (id == 'districtId') {
            setAddressInfo({ ...addressInfo, [name]: e?.value, [id]: e?.id, neighbourhoodId: e?.id })
          } else {
          setAddressInfo({ ...addressInfo, [name]: e?.value, [id]: e?.id, })
          }
        } else if (name) {
          setAddressInfo({ ...addressInfo, [name]: e?.value })
        } else {
          setAddressInfo({ ...addressInfo, [e.target.name]: e?.target.value })
        }
      }
    
      const addAdress = () => {
          if(addressInfo?.neighbourhoodId){
            dispatch(updateUserChoises({neighbourhoodId : addressInfo?.neighbourhoodId, text: "Şube"}))
            dataLayerPush({
                event: "see_branches",
                country_name: addressInfo?.province, // kullanıcı seçimine göre gelmeli
                district_name: addressInfo?.district, // kullanıcı seçimine göre gelmeli
            })
            setRegisterState && setRegisterState(stages.STAGE_BRANCH)  
            // forHome && dispatch(homeAddressReChoice({openStatus: true, step: 2})) 
            forHome &&  dispatch(updateUserChoises({deliveryType: 1, addressId: null, regionId:null}))
          }        
      }


    return (
        <div className='stageAddresses'>
          <LoaderTwo isDataLoading={loading} />
        <div className='stageAddresses-container'>

        <h1 className='stageAddresses-title'>{t('deliveryFromBranch')}</h1>
        <div className='stageAddresses-subtitle'>{t('selectRegionNearYou')}</div>
        {/* <Button className='btn-primary-outline btn-pinmap' onClick={() => dispatch(setPinMapModal({ open: true }))} icon={images.pinMap} text='Haritadan Ekle' /> */}

        <div className='addressAddDrawer-fullWidth mt-4'>
          <ReactSelect
            labelText={t('labelProvince')}
            handleChange={e => handleChange(e, "province", "provinceId")}
            value={addressInfo?.provinceId && { value: addressInfo?.province, label: addressInfo?.province, id: addressInfo?.provinceId }}
            name={"province"}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            options={provinces}
            isSearchable
          />
        </div>
        <div className='addressAddDrawer-fullWidth mt-4'>
          <ReactSelect
            labelText={t('labelDistrict')}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            handleChange={e => handleChange(e, "district", "districtId")}
            value={addressInfo?.districtId && { value: addressInfo?.district, label: addressInfo?.district, id: addressInfo?.districtId }}
            options={districts}
            isSearchable
          />
        </div>
        <Button onClick={addAdress} className={"claretredRoundedBtn"} icon={''} text={t('showBranches')} />
      </div>
      </div>
    )
}

export default ChoiceBranch